export default {
  methods: {
    initTableColumnSort(columns) {
      ;(columns || [])
        .filter(t => {
          return t.sortable
        })
        .map(t => {
          this.$set(t, 'sort', t.sort || 'none')
          return t
        })
    },
    doTableSort(columns, itemKey, sortBy, callback) {
      let idx = columns.findIndex(t => t.key === itemKey)
      if (idx < 0) {
        return
      }
      let oldIdx = columns.findIndex(t => t.sortable && t.sort != 'none')
      if (oldIdx > -1) {
        this.$set(columns[oldIdx], 'sort', 'none')
      }
      this.$set(columns[idx], 'sort', sortBy)
      callback && callback(itemKey, sortBy)
    }
  }
}
